import type { Lang } from "./types";

export function detectLang(input?: string): Lang {
  const raw = (input ?? (typeof navigator !== "undefined" ? navigator.language : "es-CL")) || "es-CL";
  return raw.toLowerCase().startsWith("en") ? "en-US" : "es-CL";
}

interface Strings {
  bannerTitle: string;
  bannerText: string;
  policyLink: string;
  acceptAll: string;
  rejectAll: string;
  customize: string;
  prefsTitle: string;
  prefsIntro: string;
  save: string;
  alwaysOn: string;
  receiptNote: string;
  fab: string;
}

const ES: Strings = {
  bannerTitle: "🍪 Tu privacidad importa",
  bannerText: "Usamos cookies para analítica y publicidad. Puedes aceptarlas, rechazarlas o elegir cuáles.",
  policyLink: "Política de cookies",
  acceptAll: "Aceptar todo",
  rejectAll: "Rechazar todo",
  customize: "Personalizar",
  prefsTitle: "Preferencias de cookies",
  prefsIntro: "Elige qué categorías permites. Puedes cambiarlo cuando quieras.",
  save: "Guardar preferencias",
  alwaysOn: "Siempre activas",
  receiptNote: "🧾 Tu elección queda registrada con un recibo verificable.",
  fab: "🍪 Preferencias de cookies",
};

const EN: Strings = {
  bannerTitle: "🍪 Your privacy matters",
  bannerText: "We use cookies for analytics and advertising. You can accept, reject, or choose.",
  policyLink: "Cookie policy",
  acceptAll: "Accept all",
  rejectAll: "Reject all",
  customize: "Customize",
  prefsTitle: "Cookie preferences",
  prefsIntro: "Choose which categories you allow. You can change this anytime.",
  save: "Save preferences",
  alwaysOn: "Always on",
  receiptNote: "🧾 Your choice is recorded with a verifiable receipt.",
  fab: "🍪 Cookie preferences",
};

export function t(lang: Lang): Strings {
  return lang === "en-US" ? EN : ES;
}
